import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useIsWorker() {
  const { user } = useAuth();
  const [isWorker, setIsWorker] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setIsWorker(false); setLoading(false); return; }

    (async () => {
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id)
        .eq("role", "worker")
        .maybeSingle();

      setIsWorker(!!data);
      setLoading(false);
    })();
  }, [user]);

  return { isWorker, loading };
}
